module.exports = __webpack_public_path__ + "img/energy1.0fd3f138.png";